import { EInvoicingAddressingLine } from '@features/eInvoicing/types/eInvoicingAddressingLine'

import { APIError } from '../../../../../utils'
import { getIsAppTestingEnvironment } from '../../../../../utils/getIsAppTestingEnvironment'
import { AddressingLineLookupStatus } from '../enums/addressingLineLookupStatus'
import { getMatchedAddressingLine } from './getMatchedAddressingLine'

interface GetAddressingLineLookupStatusOptions {
  addressingLine?: string
  addressingLines: EInvoicingAddressingLine[]
  error?: unknown
  isError?: boolean
}

export const getAddressingLineLookupStatus = ({
  addressingLine,
  addressingLines,
  error,
  isError,
}: GetAddressingLineLookupStatusOptions): AddressingLineLookupStatus => {
  const isTestingEnvironment = getIsAppTestingEnvironment()
  if (isTestingEnvironment) {
    return AddressingLineLookupStatus.Registered
  }

  if (isError) {
    return error instanceof APIError && error.statusCode === 400
      ? AddressingLineLookupStatus.Invalid
      : AddressingLineLookupStatus.Unavailable
  }

  const matchedAddressingLine = getMatchedAddressingLine(addressingLines, addressingLine)

  if (!matchedAddressingLine) {
    return AddressingLineLookupStatus.Unmatched
  }

  return matchedAddressingLine.isRegisteredAddressingLine
    ? AddressingLineLookupStatus.Registered
    : AddressingLineLookupStatus.Unregistered
}
